module.exports = __webpack_public_path__ + "static/blood-and-thunder-e05da92aaee7723366020d3e7174ecd7.jpg";